import type { InputHTMLAttributes } from "react";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";

type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string | null;
};

export default function TextInput({
  label,
  error,
  className = "",
  style,
  id,
  ...props
}: TextInputProps) {
  const inputId = id ?? props.name ?? label.toLowerCase().replace(/\W+/g, "-");

  return (
    <label className={`block ${className}`} htmlFor={inputId}>
      <span
        className="mb-1.5 block text-xs uppercase"
        style={{
          fontFamily: fonts.body,
          fontWeight: 700,
          color: `${colors.navy}88`,
          letterSpacing: "0.08em",
        }}
      >
        {label}
      </span>
      <input
        id={inputId}
        className="w-full rounded-full border px-4 py-3 text-sm outline-none transition-all duration-200 focus:shadow-md"
        style={{
          borderColor: error ? colors.berryRose : `${colors.tan}40`,
          backgroundColor: colors.cream,
          color: colors.navy,
          fontFamily: fonts.body,
          fontWeight: 600,
          ...style,
        }}
        {...props}
      />
      {error && (
        <span className="mt-1.5 block text-xs" style={{ color: colors.berryRose, fontFamily: fonts.body }}>
          {error}
        </span>
      )}
    </label>
  );
}
